var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.trad)?_c('header',[_c('img',{attrs:{"src":_vm.trad.header.logo,"alt":"Logo liveConsent"},on:{"click":_vm.backHome}}),_c('br')]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }